import { render, staticRenderFns } from "./cuilinhonor.vue?vue&type=template&id=22f00086&scoped=true&"
import script from "./cuilinhonor.vue?vue&type=script&lang=js&"
export * from "./cuilinhonor.vue?vue&type=script&lang=js&"
import style0 from "./cuilinhonor.vue?vue&type=style&index=0&id=22f00086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f00086",
  null
  
)

export default component.exports